<template>
  <vs-col class="reset-alert-height" v-if="Boolean(selected)">
    <vs-alert :active="Boolean(selected)" title="OFERTA SELECIONADA" color="dark">
      <span style="font-size: 1.15em;">{{ selected.FILIALCAMPUS }} ({{ selected.CIDADE }}) - {{ modalidade }}</span>
    </vs-alert>
  </vs-col>
</template>

<script>
import { getStepsInformation } from '../helpers/storage'

export default {
  name: 'SelectedOfferBox',
  data: () => ({
    selected: null,
    taxPayment: null
  }),
  created() {
    const stepsData = getStepsInformation()
    if (stepsData.offerSimulate) this.selected = stepsData.offerSimulate
    if (stepsData.taxPayment) this.payment = stepsData.taxPayment
  },
  computed: {
    modalidade() {
      if (this.selected.MODALIDADE === "D") return "À DISTÂNCIA"
      return `${this.selected.TURNO}`
    }
  },
}
</script>


<style>
.reset-alert-height > div {
  height: initial !important;
}
</style>
